helping = {};

helping = {
	timer: null,
	initialOrientation: window.orientation === 0 ? 'portrait' : 'landscape',
	init: function () {
		// Remove the incorrect video for the current version
		if (window.matchMedia("(max-width: 768px)").matches) {
			$('#video.js-nonXS').remove();
		} else {
			$('#video.js-XS').remove();
		}
	},
	changeSection: function () {
		let sectionNum = $(this).data('section');
		let $bodySections = $('.body-core-right');
		let $headerSections = $('.body-header-right');

		helping.showHelpingPanel();

		// Remove previous selected section
		$headerSections.find('.body-header-section').removeClass('isSelected');
		$bodySections.find('.body-core-right-section').removeClass('isSelected');

		// Mark current section as selected
		$(this).addClass('isSelected');
		$bodySections.find('[data-section="'+sectionNum+'"]').addClass('isSelected');
	},
	showHelpingPanel: function () {
		let $helpingWrapper = $('.js-helpingWrapper');
		let $helpingBodyCore = $helpingWrapper.find('.body-core');

		// Open helping panel
		if ($helpingWrapper.length > 0) {
			$helpingWrapper.addClass('isOpen');

			// Set ptoper height to core helping panel
			let minHeight = $('.app-wrapper').height() - $helpingBodyCore.offset().top + 190;
			$helpingBodyCore.css('minHeight', minHeight);
		}
	},
	closeHelpingPanel: function () {
		let $helpingWrapper = $('.js-helpingWrapper');
		let $bodySections = $('.body-core-right');
		let $headerSections = $('.body-header-right');

		// Close helping panel
		$helpingWrapper.removeClass('isOpen');

		// Remove previous selected section
		$headerSections.find('.body-header-section').removeClass('isSelected');
		$bodySections.find('.body-core-right-section').removeClass('isSelected');
	},
	toggleVideo: function () {
		let $buttonWrapper = $(this);

		if ($buttonWrapper.hasClass('paused')) {
			$buttonWrapper.removeClass('paused');
			utils.common.actionVideo($('#video'), 'play');
		} else {
			$buttonWrapper.addClass('paused');
			utils.common.actionVideo($('#video'), 'pause');
		}
	},
	clearForm: function () {
		let $form = $('.js-formHelping');

		$form.find('[name="email"]').val('').removeClass('error');
		$form.find('[name="nif"]').val('').removeClass('error');
		$form.find('[name="phone"]').val('').removeClass('error');
		$form.find('[name="name"]').val('').removeClass('error');
		$form.find('[name="total"]').val('').removeClass('error');
		$form.find('[name="country"]').val('default').removeClass('error');
		$form.find('[name="memoria"]').val('').removeClass('error');
		$form.find('[name="memoria"]').siblings('.file-text').html($form.find('[name="memoria"]').siblings('.file-text').data('text-default'));
		$form.find('[name="presupuesto"]').val('').removeClass('error');
		$form.find('[name="presupuesto"]').siblings('.file-text').html($form.find('[name="presupuesto"]').siblings('.file-text').data('text-default'));
		$form.find('[name="comments"]').val('').removeClass('error');
		$form.find('[name="accept-policy"]').prop('checked', false).removeClass('error');
	},
	submitHelping: function () {
		let $button = $(this);
		let buttonOriginalText = $button.html();
		let $form = $('.js-formHelping');

		let validationForm = utils.common.checkForm($form);
		if (validationForm.valid) {
			let email = $form.find('[name="email"]').val();
			let nif = $form.find('[name="nif"]').val();
			let phone = $form.find('[name="phone"]').val();
			let name = $form.find('[name="name"]').val();
			let total = $form.find('[name="total"]').val();
			let country = $form.find('[name="country"]').val();
			let memoria = $form.find('[name="memoria"]')[0].files[0];
			let presupuesto = $form.find('[name="presupuesto"]')[0].files[0];
			let comments = $form.find('[name="comments"]').val();
			let acceptPolicy = $form.find('[name="accept-policy"]').is(':checked');
			let dataForm = new FormData();

			dataForm.append("email", email);
			dataForm.append("nif", nif);
			dataForm.append("phone", phone);
			dataForm.append("name", name);
			dataForm.append("total", total);
			dataForm.append("country", country);
			dataForm.append("memoria", memoria);
			dataForm.append("presupuesto", presupuesto);
			dataForm.append("comments", comments);
			dataForm.append("acceptPolicy", acceptPolicy);

			$.ajax({
				type: 'POST',
				url: '/api/helping/enroll',
				processData: false,
				contentType: false,
				data: dataForm,
				headers: {
	        		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    		},
	    		beforeSend: function () {
	    			// Disable form submit button
	    			$button.prop('disabled', true);
	    			$button.html(Lang.get('common/forms.sending')+' ...');
	    		},
				success: function (r) {
					console.log(r);

					// Clear form
					helping.clearForm();

					alert(Lang.get('common/forms.form_sent'));
				},
				error: function (error) {
					console.log(error);
				},
				complete: function() {
					// Enable form submit button
					$button.prop('disabled', false);
	    			$button.html(buttonOriginalText);
				}
			});
		} else {
			alert(validationForm.message);
		}
	},
	orientationChange: function (e) {
		let initialOrient = helping.initialOrientation;
		let orient = window.orientation === 0 ? 'portrait' : 'landscape';
		let $videoWrapper = $('.js-videoContainer');

        // Pause video
        $('.js-videoToggle').addClass('paused');
        utils.common.actionVideo($('#video'), 'pause');

		if (orient === 'landscape' && orient !== initialOrient) {
			$videoWrapper.addClass('flippedHorizontal');
		} else if (orient === 'portrait' && orient !== initialOrient) {
			$videoWrapper.addClass('flippedVertical');
		} else {
			$videoWrapper.removeClass('flippedHorizontal');
			$videoWrapper.removeClass('flippedVertical');
		}
	},
	checkEmail: function () {
		clearTimeout(helping.timer);
		let self = this;
		// Check email after 500ms of inactivity
		helping.timer = setTimeout(function () {
			let email = $(self).val();
			let validEmail = utils.common.validateEmail(email);
			let dataForm = new FormData();

			dataForm.append("email", email);

			if (validEmail) { // Check the email
				$.ajax({
					type: 'POST',
					url: '/api/friend/check',
					processData: false,
					contentType: false,
					data: dataForm,
					headers: {
		        		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		    		},
					success: function (r) {
						console.log(r);
						if (r.status === 'ok') {
							$('.js-becomeFriendWrapper').removeClass('isVisible');
							$('.js-restHelpingForm').addClass('isVisible');
						} else {
							$('.js-becomeFriendWrapper').addClass('isVisible');
							$('.js-restHelpingForm').removeClass('isVisible');
						}
					},
					error: function (error) {
						console.log(error);
					}
				});
			}
		}, 500);
	},
	binds: function () {
		$('.js-formHelping').on('keydown change', '[name="email"]', this.checkEmail);
		$('.js-helpingHeaderSection').on('click', '.body-header-section', this.changeSection);
		$('.js-videoToggle').on('click', this.toggleVideo);
		$('.js-closeHelping').on('click', this.closeHelpingPanel);
		$('.js-submitHelping').on('click', this.submitHelping);
		$(window).on('orientationchange', function (e) { helping.orientationChange(e); });
	}
};

$(document).ready(function () {
    helping.binds();
    helping.init();
});
